<div class="topic-list__container">
    {#await topics}
        <LoadingState />
    {:then topics}
        {#if topics && topics.length > 0}
            <List>
                <thead slot="header">
                    <ListElement header>
                        <Cell header />
                        <Cell header>
                            <span slot="header">{i18n.topics}</span>
                        </Cell>
                    </ListElement>
                </thead>
                <tbody slot="body">
                    {#each topics as topic}
                        <ListElement
                            on:click={() => {
                                onItemSelected(topic);
                            }}
                        >
                            <Cell type="topic-icon">
                                <span class="topic-label {topic.colorSchema}" slot="data"></span>
                            </Cell>
                            <Cell type="topic-info">
                                <div slot="data">
                                    <span>{topic.name}</span>
                                    <IconButton
                                        htmlType="button"
                                        iconOnly={true}
                                        iconClass="explore-button"
                                        type="plain"
                                        ariaLabel="{getTopicButtonText(topic)}"
                                        text="{getTopicButtonText(topic)}"
                                    />
                                </div>
                            </Cell>
                        </ListElement>
                    {/each}
                </tbody>
            </List>
        {:else}
            <EmptyState iconName="plan-topics" title={i18n.noTopics} showButton={false} />
        {/if}
    {:catch error}
        <p>{error.message}</p>
    {/await}
</div>

<script>
    import { createEventDispatcher } from "svelte";

    import List from "@itslearning/prometheus/assets/lists/List/v1/List.svelte";
    import ListElement from "@itslearning/prometheus/assets/lists/ListElement/v1/ListElement.svelte";
    import Cell from "@itslearning/prometheus/assets/lists/Cell/v1/Cell.svelte";
    import IconButton from "@itslearning/prometheus/assets/inputs/IconButton/v1/IconButton.svelte";
    import EmptyState from "@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte";
    import LoadingState from "@its-ui/common-components/LoadingState/LoadingState.svelte";

    import { formatLanguageString } from "@itslearning/atlas/strings/format.js";

    export let i18n;
    export let topics;

    const dispatch = createEventDispatcher();

    function onItemSelected(item) {
        dispatch("itemSelected", item);
    }

    function getTopicButtonText(topic) {
        return formatLanguageString(i18n.planner2_TableView_Topics_Select_X, topic.name);
    }
</script>
